module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-182.ae3ecca9.svg";